import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme, screen } from '../../global/utils';

const CardFileWrapper = styled.div`
  background-color: ${getTheme('bg', 'light1')};
  border: 1px solid ${getTheme('black', '_800')};
  border-radius: ${getTheme('radius', 'm')};
  overflow: hidden;
  margin-bottom: ${getTheme('marginBottom', 's')};

  .cardfile__header {
    background-color: ${getTheme('bg', 'light2')};
    border-bottom: 1px solid ${getTheme('black', '_800')};
    padding: ${getTheme('padding', 'verticalXL')} ${getTheme('padding', 'horizontalM')};
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cardfile__content {
    padding: ${getTheme('spacer', 'l')} ${getTheme('padding', 'horizontalL')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    > :last-child {
      max-width: 100%;
      overflow: hidden;
      flex-grow: 1;
    }
    @media (max-width: ${screen('smMax')}) {
      padding: ${getTheme('spacer', 's')} ${getTheme('padding', 'horizontalS')};
      display: block;
      > :first-child {
        width: auto;
      }
    }
  }
`;

class CardFile extends Component {
  render() {
    return (
      <CardFileWrapper className={this.props.className} hasControls={this.props.hasControls}>
        <div className="cardfile__header">
          {this.props.cardTitle}
          {this.props.cardControls}
        </div>

        <div className="cardfile__content">{this.props.children}</div>
      </CardFileWrapper>
    );
  }
}

export default CardFile;



// WEBPACK FOOTER //
// ./src/components/cards/CardFile.js